// Keep route slugs separate from page copy for the lightweight route bundle.
const SUBURBS = ["naperville", "hinsdale", "oak-brook", "winnetka", "arlington-heights"];
const DESTS = ["naples-fl", "scottsdale", "frisco-tx", "brooklyn"];
export const SUBURB_CORRIDOR_SLUGS = DESTS.flatMap((d) => SUBURBS.map((s) => `${s}-to-${d}-movers`));
